import { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { theme } from '@bpba/ui-components';
import { Text } from '../Text';
import { ERROR_DESCRIPTION, ERROR_DESCRIPTION2, ERROR_LINK_MESSAGE, ERROR_TITLE } from '../../../constants/error';

export const ErrorComponent: FC = () => {
  const homeUrl = process.env.PUBLIC_URL || '/';

  return (
    <Wrapper>
      <Title tabIndex={0}>{ERROR_TITLE}</Title>
      <Divider />
      <ContentContainer tabIndex={0}>
        <StyledParagraph>{ERROR_DESCRIPTION}</StyledParagraph>
        <StyledParagraph>{ERROR_DESCRIPTION2}</StyledParagraph>
      </ContentContainer>
      <br />
      <StyledParagraph>
        <a href={homeUrl} style={{ color: theme.colors.primary[0], fontWeight: theme.fontWeights.semibold }}>
          {ERROR_LINK_MESSAGE}
        </a>
      </StyledParagraph>
    </Wrapper>
  );
};

const Wrapper = styled.div({
  padding: `${theme.space[5]}px`,
  maxWidth: '720px',
  margin: '0 auto',
});

const Title = styled.h1({
  color: theme.colors.primary[0],
  marginTop: `${theme.space[3]}px`,
  marginBottom: `${theme.space[2]}px`,
  fontWeight: theme.fontWeights.regular,
  fontSize: '32px',
  lineHeight: '40px',
  width: 'fit-content',
});

const Divider = styled.div({
  borderBottomStyle: 'solid',
  borderBottomWidth: '1px',
  borderBottomColor: theme.colors.primary[0],
  marginBottom: `${theme.space[3]}px`,
  marginTop: `${theme.space[3]}px`,
});

const ContentContainer = styled.div({
  width: 'fit-content',
});

type StyledParagraphProps = { children: ReactNode };
const StyledParagraph: FC<StyledParagraphProps> = ({ children }) => (
  <Text fontSize={[14, null, 16]} lineHeight={['18px', null, '21px']}>
    {children}
  </Text>
);
